import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const AuthInterstitial = ({ children }) => {
    return (
        <Styled.Container>
            <Styled.Title>{children}</Styled.Title>
        </Styled.Container>
    );
};

AuthInterstitial.propTypes = {
    children: PropTypes.node.isRequired
};

export default AuthInterstitial;
